<div data-tour-id="autouzupelnianie">
<ng-container *ngIf="settings.has('automaticNumbering')">
    <automatic-numbering ></automatic-numbering>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('numberingType')">
    <app-numbering-type ></app-numbering-type>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('numberFormat')">
    <app-number-format></app-number-format>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('documentsSymbols')">
    <app-documents-symbols></app-documents-symbols>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('placeOfIssue')">
    <place-of-issue></place-of-issue>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('placeOfIssue')">
    <default-comments></default-comments>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('signatures')">
    <signatures></signatures>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('enableGTU')">
    <enable-gtu></enable-gtu>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('enablePKWiU')">
    <enable-pkwiu></enable-pkwiu>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('autoAnnotations')">
    <auto-annotations></auto-annotations>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('showKsefQrCode')">
    <show-ksef-qr></show-ksef-qr>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('showConvertedAmount')">
    <show-converted-amount></show-converted-amount>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('priceInputMode')">
    <price-input-mode></price-input-mode>
    <mat-divider class="my-4 w-full max-w-200"></mat-divider>
</ng-container>

<ng-container *ngIf="settings.has('defaultPaymentStatus')">
    <default-payment-status></default-payment-status>
</ng-container>
</div>